export default __webpack_public_path__ + "static/user-ee4cb8349368e3843341245b1fcfb750.gif";